import React from "react";
import { FaTrash, FaChevronCircleUp, FaChevronCircleDown } from "react-icons/fa";

export default function CartItems({ cartItem, increment, decrement, removeItem }) {
    const { size,nr, pName, count, total, extratopping,dressing } = cartItem;
	console.log(cartItem)

	return (
		<div className="row mt-5 mt-lg-0 text-capitalize text-center align.items-center">

			<div className="col-10 mx-4 text-left col-lg-2 pb-2">
				<h6 className="font-weight-bold"> {nr}. {pName}</h6>
                <span className="font-italic font-weight-light"> {size}</span>
			</div>
			<div className="col-10 mx-auto col-lg-2 pb-2">
                <p>{extratopping.map((topping)=>{return (<span key={topping}>{topping}, </span>)})}<span>{dressing}</span></p>
			</div>
			<div className="col-10 mx-auto col-lg-2 my-2 my-lg-0">
				<div className="d-flex justify-content-center">
					<div>
						<FaChevronCircleDown className="cart-icon text-primary" onClick={() => decrement(cartItem)} />
						<span className="text-title text-muted mx-3">{count}</span>
						<FaChevronCircleUp className="cart-icon text-primary" onClick={() => increment(cartItem)} />
					</div>
				</div>
			</div>
			<div className="col-10 mx-auto col-lg-2">
				<FaTrash className="cart-icon text-danger" onClick={() => removeItem(cartItem)} />
			</div>
			<div className="col-10 mx-auto col-lg-2 ">
				<strong className="text-muted">total : {total}kr</strong>
			</div>
		</div>
	);
}